(ns ycweb.app.website.demo.test
  (:require
    [ycweb.components.flow :as flow]
    [rum.core :as rum]
    [ycweb.util.core :as u]
    [ycweb.components.scroll :as scroll]
    [ycweb.components.buttons :as buttons]
    [ycweb.components.forms :as forms]
    [ycweb.components.common :as cmn]
    [ycweb.util.comms :as comms]
    [ycweb.components.grid :as grid]
    [ycweb.components.toaster :as toaster]
    [ycweb.components.transitions :as t]
    [ycweb.components.headings :as headings]
    [ycweb.app.website.myaccount.common :as awm.common]
    [ajax.core :as ajax]))


(rum/defc test-page < rum/reactive [app-atom]
  (list
    [:p "Testing page 1"]))


(defmethod flow/render-screen :web.demo/test [app-atom _]
  (test-page app-atom))

